import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.graph');
import { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import cytoscape from 'cytoscape';


type IdentityResolutionCountName =
    'adjudication_pending_count'
    | 'separation_confirmed_count'
    | 'canonical_linked_candidate_count';

type IdentityResolutionNumericName =
    IdentityResolutionCountName | 'canonical_node_count';

interface IdentityResolutionStats {
    adjudication_pending_count: number | null;
    separation_confirmed_count: number | null;
    canonical_linked_candidate_count: number | null;
    canonical_node_count: number | null;
    classification_available: boolean | null;
}

interface GraphSnapshotData {
    nodes: any[];
    edges: any[];
    canonical_facts: any[];
    evidence: any[];
    audit_events: any[];
    stats?: any;
    human_review_summary?: any;
    identity_resolution_stats?: IdentityResolutionStats | null;
    [key: string]: any;
}

@Component({
    selector: 'wiz-page-graph',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.graph/view.scss */
:host {
  display: block;
  height: 100%;
}

.instance-graph {
  position: relative;
  width: 100%;
}

.instance-graph canvas {
  outline: none;
}

.reviewed-example-graph {
  background-image: radial-gradient(#dbe5e1 1px, transparent 1px);
  background-size: 22px 22px;
}`],
})
export class PageGraphComponent implements OnInit, AfterViewInit, OnDestroy {
    public loading: boolean = true;
    public actionBusy: boolean = false;
    public errorMessage: string = '';
    public successMessage: string = '';
    public actor: string = '';
    public canWrite: boolean = false;
    public canReview: boolean = false;

    public documents: any[] = [];
    public ontology: any = {};
    public selectedDocumentId: string = '';
    public snapshots: any[] = [];
    public currentSnapshotId: string = '';
    public selectedSnapshotId: string = '';
    public snapshotData: GraphSnapshotData = {
        nodes: [], edges: [], canonical_facts: [], evidence: [], audit_events: [],
        identity_resolution_stats: null
    };
    public selectedGraphItem: any = null;
    public selectedReviewFact: any = null;
    public viewMode: 'review' | 'graph' | 'example' = 'review';
    public reviewQuery: string = '';
    public humanReviewFilter: string = '';
    public reviewReason: string = '';
    public reviewReasonCode: string = '';
    public selectedReviewEvidenceIds: string[] = [];
    public reviewBusy: boolean = false;

    public query: string = '';
    public nodeTypeFilter: string = '';
    public predicateFilter: string = '';
    public statusFilter: string = '';
    public publishReason: string = '';
    public expertReviewReason: string = '';
    public rollbackReason: string = '';
    public graphLayout: string = 'cose';
    public expertReviewPending: boolean = true;
    public expertReview: any = null;
    public currentQualityGate: any = { status: 'pending' };

    public reviewedExampleNodes: any[] = [
        { id: 'example-kangxi', label: '강희제', node_type: 'Person', position: { x: 90, y: 80 } },
        { id: 'example-mukden', label: '목극등', node_type: 'Person', position: { x: 90, y: 245 } },
        { id: 'example-bakgwon', label: '박권', node_type: 'Person', position: { x: 90, y: 410 } },
        { id: 'example-survey', label: '1712년 백두산 경계 조사', node_type: 'Event', position: { x: 380, y: 170 } },
        { id: 'example-install', label: '백두산정계비 설치', node_type: 'Event', position: { x: 380, y: 355 } },
        { id: 'example-baekdu', label: '백두산\n長白山 · 장백산', node_type: 'Place', aliases: ['長白山', '장백산'], position: { x: 730, y: 100 } },
        { id: 'example-1712', label: '1712년', node_type: 'TimePeriod', position: { x: 730, y: 275 } },
        { id: 'example-stele', label: '백두산정계비', node_type: 'Artifact', position: { x: 730, y: 445 } }
    ];
    public reviewedExampleFacts: any[] = [
        {
            id: 'example-ordered', subject_id: 'example-kangxi', predicate: 'ORDERED', object_id: 'example-survey', status: 'approved',
            evidence: [{ id: 'example-evidence-1', evidence_text: '강희제가 목극등에게 국경 조사를 명했다.', source: '첨부 검수 시나리오' }],
            human_review: { decision: 'approved', reason_code: 'direct_source_support', comment: '명령 주체와 조사 사건이 원문에 직접 드러납니다.', reviewer: '검수 완료 예시', version: 'review-v1.0' }
        },
        {
            id: 'example-mukden-survey', subject_id: 'example-mukden', predicate: 'PARTICIPATED_IN', object_id: 'example-survey', status: 'approved',
            evidence: [{ id: 'example-evidence-2', evidence_text: '청은 조선과의 경계를 조사하도록 목극등을 파견하였다.', source: '첨부 목업 문맥' }],
            human_review: { decision: 'approved', reason_code: 'direct_source_support', comment: '목극등의 조사 참여가 직접 서술됩니다.', reviewer: '검수 완료 예시', version: 'review-v1.0' }
        },
        {
            id: 'example-bakgwon-survey', subject_id: 'example-bakgwon', predicate: 'PARTICIPATED_IN', object_id: 'example-survey', status: 'approved',
            evidence: [{ id: 'example-evidence-3', evidence_text: '박권은 접반사로서 목극등과의 경계 조사에 참여하였다.', source: '첨부 누락 관계 예시' }],
            human_review: { decision: 'approved', reason_code: 'reviewer_added', comment: '자동 추출 누락 관계를 원문 근거로 추가했습니다.', reviewer: '검수 완료 예시', version: 'review-v1.0' }
        },
        {
            id: 'example-survey-place', subject_id: 'example-survey', predicate: 'OCCURRED_AT', object_id: 'example-baekdu', status: 'approved',
            evidence: [{ id: 'example-evidence-4', evidence_text: '1712년 목극등과 박권은 백두산 일대를 조사하였다.', source: '첨부 검수 시나리오' }],
            human_review: { decision: 'approved', reason_code: 'place_scope_confirmed', comment: '언급 시기와 무관하게 동일한 백두산 장소로 연결합니다.', reviewer: '검수 완료 예시', version: 'review-v1.0' }
        },
        {
            id: 'example-survey-time', subject_id: 'example-survey', predicate: 'OCCURRED_DURING', object_id: 'example-1712', status: 'approved',
            evidence: [{ id: 'example-evidence-5', evidence_text: '1712년 목극등과 박권은 백두산 일대를 조사하였다.', source: '첨부 검수 시나리오' }],
            human_review: { decision: 'approved', reason_code: 'time_expression_confirmed', comment: '조사 사건의 시기를 1712년으로 확정했습니다.', reviewer: '검수 완료 예시', version: 'review-v1.0' }
        },
        {
            id: 'example-mukden-install', subject_id: 'example-mukden', predicate: 'PARTICIPATED_IN', object_id: 'example-install', status: 'approved',
            evidence: [{ id: 'example-evidence-6', evidence_text: '1712년 목극등은 백두산에 올라 정계비를 세웠다.', source: '첨부 목업 원문 예시' }],
            human_review: { decision: 'approved', reason_code: 'direct_source_support', comment: '설치 행위자의 참여 관계를 확인했습니다.', reviewer: '검수 완료 예시', version: 'review-v1.0' }
        },
        {
            id: 'example-install-place', subject_id: 'example-install', predicate: 'OCCURRED_AT', object_id: 'example-baekdu', status: 'approved',
            evidence: [{ id: 'example-evidence-7', evidence_text: '1712년 목극등은 백두산에 올라 정계비를 세웠다.', source: '첨부 목업 원문 예시' }],
            human_review: { decision: 'approved', reason_code: 'direct_source_support', comment: '설치 사건의 장소가 백두산임을 확인했습니다.', reviewer: '검수 완료 예시', version: 'review-v1.0' }
        },
        {
            id: 'example-install-time', subject_id: 'example-install', predicate: 'OCCURRED_DURING', object_id: 'example-1712', status: 'approved',
            evidence: [{ id: 'example-evidence-8', evidence_text: '1712년 목극등은 백두산에 올라 정계비를 세웠다.', source: '첨부 목업 원문 예시' }],
            human_review: { decision: 'approved', reason_code: 'time_expression_confirmed', comment: '설치 사건의 시기를 확인했습니다.', reviewer: '검수 완료 예시', version: 'review-v1.0' }
        },
        {
            id: 'example-install-produced', subject_id: 'example-install', predicate: 'PRODUCED', object_id: 'example-stele', status: 'approved',
            evidence: [{ id: 'example-evidence-9', evidence_text: '1712년 목극등은 백두산에 올라 정계비를 세웠다.', source: '첨부 목업 원문 예시' }],
            human_review: { decision: 'approved', reason_code: 'artifact_production_confirmed', comment: '설치 사건이 정계비를 산출한 관계를 확인했습니다.', reviewer: '검수 완료 예시', version: 'review-v1.0' }
        }
    ];
    public selectedExampleFact: any = this.reviewedExampleFacts[0];

    private graphInstance: any = null;
    private activeGraphLayout: any = null;
    private graphInitTimer: any = null;
    private viewReady: boolean = false;
    private requestedDocumentId: string = '';
    private requestedReviewStage: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const query = new URLSearchParams(location.search);
        this.requestedDocumentId = String(query.get('document_id') || '').trim();
        this.requestedReviewStage = String(query.get('review_stage') || '').trim();
        if (this.requestedReviewStage === 'relations') this.viewMode = 'review';
        const session = this.service.auth.session || {};
        this.actor = String(session?.id || '');
        this.canWrite = ['admin', 'editor'].includes(
            String(session?.role || '').toLowerCase()
        ) && !!this.actor;
        this.canReview = this.canWrite;
        await this.loadOverview();
    }

    public ngAfterViewInit() {
        this.viewReady = true;
        this.scheduleGraphInit();
    }

    public ngOnDestroy() {
        if (this.graphInitTimer) clearTimeout(this.graphInitTimer);
        this.graphInitTimer = null;
        this.destroyGraph();
    }

    private setError(message: string) {
        this.errorMessage = message;
        this.successMessage = '';
    }

    private setSuccess(message: string) {
        this.successMessage = message;
        this.errorMessage = '';
    }

    private qualityGatePassed(value: any): boolean {
        if (value === true || value?.release_ready === true) return true;
        const status = String(value?.status || value || '').toLowerCase();
        return status === 'passed' || status === 'release_ready';
    }

    public async loadOverview() {
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call('overview', {
                document_id: this.selectedDocumentId || ''
            });
            if (response.code !== 200) {
                this.setError(response.data?.message || '그래프 발행 이력을 불러오지 못했습니다.');
                return;
            }
            this.documents = response.data?.documents || [];
            this.ontology = response.data?.ontology || {};
            const graph = response.data?.graph || {};
            if (!this.selectedDocumentId && this.documents.length) {
                const currentSnapshot = (graph?.snapshots || []).find((item: any) =>
                    String(item?.id || '') === String(graph?.current_snapshot_id || '')
                );
                const graphDocumentId = String(
                    currentSnapshot?.document_id
                    || graph?.snapshots?.[0]?.document_id
                    || ''
                );
                const requestedDocument = this.documents.find((item: any) =>
                    String(item?.id || '') === this.requestedDocumentId
                );
                const defaultDocument = requestedDocument || this.documents.find((item: any) =>
                    String(item?.id || '') === graphDocumentId
                ) || this.documents[0];
                this.selectedDocumentId = String(defaultDocument?.id || '');
                await this.loadOverview();
                return;
            }
            this.snapshots = graph?.snapshots || [];
            this.currentSnapshotId = String(graph?.current_snapshot_id || '');
            this.selectedSnapshotId = this.currentSnapshotId
                || String(this.snapshots[0]?.id || '');
            this.currentQualityGate = graph?.quality_gate || { status: 'pending' };
            this.expertReview = graph?.expert_review || null;
            this.expertReviewPending = !this.qualityGatePassed(
                this.currentQualityGate
            );
            if (this.selectedSnapshotId) await this.loadSnapshot();
            else this.resetSnapshot();
        } catch (_error) {
            this.setError('그래프 발행 이력을 불러오지 못했습니다.');
        } finally {
            this.loading = false;
            await this.service.render();
            this.scheduleGraphInit();
            this.scrollToRequestedReviewStage();
        }
    }

    private resetSnapshot() {
        this.snapshotData = {
            nodes: [], edges: [], canonical_facts: [], evidence: [], audit_events: [],
            identity_resolution_stats: null
        };
        this.selectedGraphItem = null;
        this.selectedReviewFact = null;
        this.scheduleGraphInit();
    }

    public async documentChanged() {
        this.selectedSnapshotId = '';
        this.currentSnapshotId = '';
        this.snapshots = [];
        this.resetSnapshot();
        await this.loadOverview();
    }

    public async snapshotChanged() {
        await this.loadSnapshot();
    }

    public async loadSnapshot() {
        if (!this.selectedSnapshotId) {
            this.resetSnapshot();
            await this.service.render();
            return;
        }
        this.loading = true;
        await this.service.render();
        try {
            const response = await wiz.call('snapshot', {
                snapshot_id: this.selectedSnapshotId,
                query: this.query.trim(),
                node_type: this.nodeTypeFilter,
                predicate: this.predicateFilter,
                status: this.statusFilter
            });
            if (response.code !== 200) {
                this.setError(response.data?.message || '인스턴스 지식그래프를 불러오지 못했습니다.');
                return;
            }
            const previousFactId = String(this.selectedReviewFact?.id || '');
            this.snapshotData = response.data || {};
            this.selectedGraphItem = null;
            const facts = this.snapshotData?.canonical_facts || [];
            this.selectedReviewFact = facts.find((item: any) =>
                String(item?.id || '') === previousFactId
            ) || facts.find((item: any) => !item?.human_review) || facts[0] || null;
            this.prepareReviewEvidenceSelection();
        } catch (_error) {
            this.setError('인스턴스 지식그래프를 불러오지 못했습니다.');
        } finally {
            this.loading = false;
            await this.service.render();
            this.scheduleGraphInit();
        }
    }

    public async applyFilters() {
        await this.loadSnapshot();
    }

    public async setViewMode(mode: 'review' | 'graph' | 'example') {
        this.viewMode = mode;
        await this.service.render();
        if (mode === 'graph' || mode === 'example') this.scheduleGraphInit();
    }

    public extractionRecommendationUrl(step: 'candidates' | 'identity'): string {
        const query = new URLSearchParams();
        query.set('review_mode', 'graph');
        query.set('review_step', step);
        if (this.selectedDocumentId) query.set('document_id', this.selectedDocumentId);
        const hash = step === 'identity' ? '#entity-resolution' : '#candidate-recommendations';
        return `/extraction?${query.toString()}${hash}`;
    }

    private scrollToRequestedReviewStage() {
        if (this.requestedReviewStage !== 'relations') return;
        setTimeout(() => {
            document.getElementById('relation-source-review')?.scrollIntoView({
                behavior: 'smooth', block: 'start'
            });
        }, 80);
    }

    public humanReviewSummary(): any {
        return {
            total_count: 0,
            reviewed_count: 0,
            pending_count: 0,
            approved_count: 0,
            changes_requested_count: 0,
            hold_count: 0,
            rejected_count: 0,
            completion_percent: 0,
            ...(this.snapshotData?.human_review_summary || {})
        };
    }

    public reviewProgressPercent(): number {
        const value = Number(this.humanReviewSummary()?.completion_percent || 0);
        return Math.max(0, Math.min(100, Number.isFinite(value) ? value : 0));
    }

    private reviewDecisionValue(fact: any): string {
        return String(fact?.human_review?.decision || 'pending');
    }

    public humanReviewStatusLabel(value: any): string {
        const labels: any = {
            pending: '미검수',
            approved: '승인',
            changes_requested: '수정 필요',
            hold: '보류',
            rejected: '제외'
        };
        return labels[String(value || 'pending')] || String(value || '-');
    }

    public humanReviewStatusClass(value: any): string {
        const classes: any = {
            pending: 'border-slate-200 bg-slate-50 text-slate-700',
            approved: 'border-emerald-200 bg-emerald-50 text-emerald-800',
            changes_requested: 'border-red-200 bg-red-50 text-red-800',
            hold: 'border-amber-200 bg-amber-50 text-amber-900',
            rejected: 'border-slate-300 bg-slate-100 text-slate-700'
        };
        return classes[String(value || 'pending')] || classes.pending;
    }

    public predicateLabel(value: any): string {
        const predicate = String(value || '-');
        const labels: any = {
            AUTHORED: '저술',
            OCCURRED_AT: '발생 장소',
            OCCURRED_DURING: '발생 시기',
            PARTICIPATED_IN: '참여',
            PRODUCED: '생산',
            ORDERED: '명령'
        };
        return labels[predicate] ? `${labels[predicate]} · ${predicate}` : predicate;
    }

    public reviewFacts(): any[] {
        const query = this.reviewQuery.trim().toLocaleLowerCase();
        const priorities: any = {
            pending: 0, changes_requested: 1, hold: 2, rejected: 3, approved: 4
        };
        return (this.snapshotData?.canonical_facts || []).filter((fact: any) => {
            const decision = this.reviewDecisionValue(fact);
            if (this.humanReviewFilter && decision !== this.humanReviewFilter) {
                return false;
            }
            if (!query) return true;
            const evidenceText = (fact?.evidence || []).map((item: any) =>
                item?.evidence_text || item?.text || ''
            ).join(' ');
            return [
                this.nodeLabel(
                    fact?.subject_canonical_entity_id || fact?.subject_entity_id
                ),
                this.predicateLabel(fact?.predicate),
                this.nodeLabel(
                    fact?.object_canonical_entity_id || fact?.object_entity_id
                ),
                evidenceText
            ].join(' ').toLocaleLowerCase().includes(query);
        }).sort((left: any, right: any) => {
            const leftDecision = this.reviewDecisionValue(left);
            const rightDecision = this.reviewDecisionValue(right);
            return (priorities[leftDecision] ?? 9) - (priorities[rightDecision] ?? 9)
                || String(left?.predicate || '').localeCompare(String(right?.predicate || ''));
        });
    }

    public nodeLabel(reference: any): string {
        const key = String(reference || '');
        if (!key) return '-';
        const node = (this.snapshotData?.nodes || []).find((item: any) =>
            [item?.id, item?.node_key, item?.canonical_entity_id]
                .map((value: any) => String(value || ''))
                .includes(key)
        );
        return String(
            node?.canonical_name || node?.preferred_label || node?.label || key || '-'
        );
    }

    public factEvidence(fact: any): any[] {
        return fact?.evidence || fact?.evidence_links || [];
    }

    public humanReviewHistory(fact: any): any[] {
        return [...(fact?.human_reviews || [])].reverse();
    }

    private prepareReviewEvidenceSelection() {
        this.selectedReviewEvidenceIds = this.factEvidence(
            this.selectedReviewFact
        ).map((item: any) => String(item?.id || '')).filter(Boolean);
        this.reviewReasonCode = '';
        this.reviewReason = '';
    }

    public reviewEvidenceSelected(evidenceId: any): boolean {
        return this.selectedReviewEvidenceIds.includes(String(evidenceId || ''));
    }

    public async toggleReviewEvidence(evidenceId: any) {
        const value = String(evidenceId || '');
        if (!value) return;
        this.selectedReviewEvidenceIds = this.reviewEvidenceSelected(value)
            ? this.selectedReviewEvidenceIds.filter((item) => item !== value)
            : [...this.selectedReviewEvidenceIds, value];
        await this.service.render();
    }

    public async selectReviewFact(fact: any) {
        this.selectedReviewFact = fact;
        this.prepareReviewEvidenceSelection();
        await this.service.render();
    }

    public reviewDecisionBlocked(): boolean {
        return this.reviewBusy
            || !this.canReview
            || !this.isCurrentSnapshot()
            || String(this.snapshotData?.publication?.publication_mode || '') !== 'canonical'
            || !this.selectedReviewFact?.id
            || !this.selectedReviewEvidenceIds.length
            || !this.reviewReasonCode
            || !this.reviewReason.trim();
    }

    public async saveHumanReview(
        decision: 'approved' | 'changes_requested' | 'hold' | 'rejected'
    ) {
        if (this.reviewDecisionBlocked()) {
            this.setError('원문 근거, 검수 사유, 의견과 현재 Canonical 그래프 권한을 확인해주세요.');
            await this.service.render();
            return;
        }
        const factId = String(this.selectedReviewFact.id);
        this.reviewBusy = true;
        await this.service.render();
        try {
            const response = await wiz.call('review_fact', {
                snapshot_id: this.selectedSnapshotId,
                canonical_fact_id: factId,
                decision,
                reason: this.reviewReason.trim(),
                reason_code: this.reviewReasonCode,
                evidence_ids: JSON.stringify(this.selectedReviewEvidenceIds)
            });
            if (response.code !== 200) {
                this.setError(response.data?.message || '검수 결과를 저장하지 못했습니다.');
                return;
            }
            const review = response.data?.review_decision;
            const facts = this.snapshotData?.canonical_facts || [];
            const index = facts.findIndex((item: any) => String(item?.id) === factId);
            if (index >= 0 && review) {
                const previous = facts[index];
                const updated = {
                    ...previous,
                    human_review: review,
                    human_reviews: [...(previous?.human_reviews || []), review]
                };
                facts[index] = updated;
                this.selectedReviewFact = updated;
                (this.snapshotData?.edges || []).forEach((edge: any) => {
                    if (String(edge?.canonical_fact_id || '') === factId) {
                        edge.human_review = review;
                    }
                });
            }
            this.snapshotData.human_review_summary =
                response.data?.human_review_summary || this.humanReviewSummary();
            this.reviewReason = '';
            this.reviewReasonCode = '';
            this.setSuccess(`${this.humanReviewStatusLabel(decision)} 결과와 의견을 이력으로 저장했습니다.`);
        } catch (_error) {
            this.setError('검수 결과를 저장하지 못했습니다.');
        } finally {
            this.reviewBusy = false;
            await this.service.render();
        }
    }

    public publishBlocked(): boolean {
        return this.expertReviewPending
            || !this.canWrite
            || !this.selectedDocumentId
            || !this.publishReason.trim();
    }

    public expertReviewBlocked(): boolean {
        return this.actionBusy
            || !this.canWrite
            || !this.selectedDocumentId
            || !this.expertReviewReason.trim();
    }

    public expertReviewStatusLabel(): string {
        const status = String(this.expertReview?.status || 'pending');
        return ({
            running: '검수·토론 진행 중',
            approved: '합의 승인 · 승인 항목 그래프 생성',
            unresolved: '미합의 항목 보류',
            failed: '검수 실패',
            pending: '검수 전'
        } as any)[status] || status;
    }

    public expertReviewCount(name: string): number {
        return Number(this.expertReview?.summary?.[name] || 0);
    }

    public async runExpertReview() {
        if (this.expertReviewBlocked()) {
            this.setError('admin 또는 editor 권한과 전문가 검수 사유가 필요합니다.');
            await this.service.render();
            return;
        }
        const accepted = await this.service.modal.show({
            title: '두 전문가 에이전트 검수·토론',
            message: '역사 전문가와 지식그래프 전문가가 독립 검수한 뒤 상호 토론합니다. 두 에이전트의 합의를 승인으로 기록하고 승인 항목만 그래프로 생성하며, 미합의 항목은 보류합니다.',
            action: '검수 후 생성',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!accepted) return;
        this.actionBusy = true;
        await this.service.render();
        try {
            const response = await wiz.call('review_and_generate', {
                document_id: this.selectedDocumentId,
                ontology_version_id: this.ontology?.id || '',
                reason: this.expertReviewReason.trim()
            });
            if (response.code !== 200) {
                this.setError(
                    response.data?.message || '전문가 검수·그래프 생성을 완료하지 못했습니다.'
                );
            } else {
                const review = response.data?.expert_review || {};
                this.expertReviewReason = '';
                this.setSuccess(review?.status === 'approved'
                    ? '두 전문가가 합의한 승인 항목으로 지식그래프를 생성했습니다.'
                    : '두 전문가의 미합의 항목을 보류한 provisional 검토 그래프를 생성했습니다.');
                await this.loadOverview();
            }
        } catch (_error) {
            this.setError('전문가 검수·토론 또는 그래프 생성을 완료하지 못했습니다.');
        } finally {
            this.actionBusy = false;
            await this.service.render();
        }
    }

    public async publishGraph(provisional: boolean = false) {
        if (this.expertReviewPending && !provisional) {
            this.setError('전문가 검수가 완료되기 전에는 후보 그래프를 canonical fact로 발행할 수 없습니다.');
            await this.service.render();
            return;
        }
        if (!this.canWrite || !this.selectedDocumentId || !this.publishReason.trim()) {
            this.setError('admin 또는 editor 권한과 발행 사유가 필요합니다.');
            await this.service.render();
            return;
        }
        const accepted = await this.service.modal.show({
            title: provisional ? '검토용 근거 그래프 생성' : 'Canonical Fact 스냅샷 발행',
            message: provisional
                ? '미해결 endpoint와 전문가 검수 대기 상태를 provisional로 명시한 검토용 스냅샷을 만듭니다.'
                : '승인 후보만 원문 근거와 함께 불변 스냅샷으로 발행합니다. 후보 승인은 역사적 사실 확정과 다릅니다.',
            action: '발행',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!accepted) return;
        this.actionBusy = true;
        await this.service.render();
        try {
            const response = await wiz.call('publish', {
                document_id: this.selectedDocumentId,
                ontology_version_id: this.ontology?.id || '',
                reason: this.publishReason.trim(),
                publication_mode: provisional ? 'provisional' : 'canonical'
            });
            if (response.code !== 200) {
                this.setError(response.data?.message || '지식그래프를 발행하지 못했습니다.');
            } else {
                this.publishReason = '';
                const mode = response.data?.publication_mode
                    || response.data?.publication?.publication_mode
                    || (provisional ? 'provisional' : 'canonical');
                this.setSuccess(mode === 'canonical'
                    ? '원문 근거를 포함한 새 Canonical Fact 스냅샷을 발행했습니다.'
                    : '전문가 검수 대기 상태의 provisional 근거 그래프 스냅샷을 만들었습니다.');
                await this.loadOverview();
            }
        } catch (_error) {
            this.setError('지식그래프를 발행하지 못했습니다.');
        } finally {
            this.actionBusy = false;
            await this.service.render();
        }
    }

    public isCurrentSnapshot(): boolean {
        return !!this.selectedSnapshotId && this.selectedSnapshotId === this.currentSnapshotId;
    }

    public async rollbackGraph() {
        if (!this.canWrite || !this.selectedSnapshotId || !this.rollbackReason.trim()) {
            this.setError('admin 또는 editor 권한, 대상 스냅샷, 되돌리기 사유가 필요합니다.');
            await this.service.render();
            return;
        }
        const accepted = await this.service.modal.show({
            title: '지식그래프 버전 되돌리기',
            message: '선택한 과거 스냅샷을 새 current 상태로 지정합니다. 기존 스냅샷과 감사 이력은 삭제하지 않습니다.',
            action: '되돌리기',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!accepted) return;
        this.actionBusy = true;
        await this.service.render();
        try {
            const response = await wiz.call('rollback', {
                snapshot_id: this.selectedSnapshotId,
                reason: this.rollbackReason.trim()
            });
            if (response.code !== 200) {
                this.setError(response.data?.message || '그래프 버전을 되돌리지 못했습니다.');
            } else {
                this.rollbackReason = '';
                this.setSuccess('과거 스냅샷을 새 current 상태로 지정하고 감사 이력을 남겼습니다.');
                await this.loadOverview();
            }
        } catch (_error) {
            this.setError('그래프 버전을 되돌리지 못했습니다.');
        } finally {
            this.actionBusy = false;
            await this.service.render();
        }
    }

    public nodeTypes(): string[] {
        const values = (this.snapshotData?.nodes || []).map((item: any) =>
            String(item?.node_type || item?.entity_type || item?.type || '')
        ).filter(Boolean);
        return Array.from(new Set(values)).sort();
    }

    public predicates(): string[] {
        const facts = Array.isArray(this.snapshotData?.canonical_facts)
            ? this.snapshotData.canonical_facts : [];
        const edges = Array.isArray(this.snapshotData?.edges)
            ? this.snapshotData.edges : [];
        const values = [...facts, ...edges].map((item: any) =>
            String(item?.predicate || '')
        ).filter(Boolean);
        return Array.from(new Set(values)).sort();
    }

    public graphNodeCount(): number {
        const value = this.snapshotData?.stats?.node_count;
        return value !== undefined && value !== null
            ? Number(value) : (this.snapshotData?.nodes || []).length;
    }

    private identityResolutionStat(name: IdentityResolutionNumericName): number | null {
        const value = this.snapshotData?.identity_resolution_stats?.[name];
        if (value === undefined || value === null) return null;
        const count = Number(value);
        return Number.isFinite(count) ? count : null;
    }

    public identityClassificationAvailable(): boolean {
        return this.snapshotData?.identity_resolution_stats
            ?.classification_available === true;
    }

    public identityResolutionCountLabel(name: IdentityResolutionCountName): string {
        if (!this.identityClassificationAvailable()) return '집계 정보 없음';
        const value = this.identityResolutionStat(name);
        return value === null ? '집계 정보 없음' : String(value);
    }

    public canonicalNodeCount(): number {
        const identityValue = this.identityResolutionStat('canonical_node_count');
        if (identityValue !== null) return identityValue;
        const value = this.snapshotData?.stats?.canonical_entity_count;
        if (value !== undefined && value !== null) return Number(value);
        return (this.snapshotData?.nodes || []).filter((item: any) =>
            !!item?.canonical_entity_id
        ).length;
    }

    public graphEdgeCount(): number {
        const value = this.snapshotData?.stats?.edge_count;
        return value !== undefined && value !== null
            ? Number(value) : (this.snapshotData?.edges || []).length;
    }

    public canonicalFactCount(): number {
        const value = this.snapshotData?.stats?.canonical_fact_count;
        return value !== undefined && value !== null
            ? Number(value) : (this.snapshotData?.canonical_facts || []).length;
    }

    public evidenceCount(): number {
        const value = this.snapshotData?.stats?.evidence_count;
        return value !== undefined && value !== null ? Number(value) : 0;
    }

    private workflowStageDone(stage: number): boolean {
        const summary = this.humanReviewSummary();
        if (stage === 1) return this.evidenceCount() > 0;
        if (stage === 2) {
            return this.identityClassificationAvailable()
                && Number(this.identityResolutionStat('adjudication_pending_count') || 0) === 0;
        }
        if (stage === 3) {
            return Number(summary.total_count || 0) > 0
                && Number(summary.pending_count || 0) === 0;
        }
        if (stage === 4) {
            return this.workflowStageDone(3)
                && Number(summary.approved_count || 0) > 0
                && Number(summary.changes_requested_count || 0) === 0
                && Number(summary.hold_count || 0) === 0
                && this.qualityGatePassed(this.currentQualityGate);
        }
        if (stage === 5) return this.workflowStageDone(4);
        return false;
    }

    public workflowStageStatus(stage: number): 'done' | 'current' | 'pending' {
        if (this.workflowStageDone(stage)) return 'done';
        const firstIncomplete = [1, 2, 3, 4, 5].find(
            (value) => !this.workflowStageDone(value)
        );
        return stage === firstIncomplete ? 'current' : 'pending';
    }

    public workflowStatusLabel(stage: number): string {
        const status = this.workflowStageStatus(stage);
        return status === 'done' ? '완료' : status === 'current' ? '진행 필요' : '대기';
    }

    public workflowStatusClass(stage: number): string {
        const status = this.workflowStageStatus(stage);
        if (status === 'done') return 'border-emerald-200 bg-emerald-50 text-emerald-800';
        if (status === 'current') return 'border-violet-300 bg-violet-50 text-violet-800';
        return 'border-slate-200 bg-slate-50 text-slate-500';
    }

    public workflowValue(stage: number): string {
        if (stage === 1) return `원문 근거 ${this.evidenceCount()}개`;
        if (stage === 2) {
            return this.identityClassificationAvailable()
                ? `판별 대기 ${this.identityResolutionCountLabel('adjudication_pending_count')}개`
                : '판별 집계 확인 필요';
        }
        if (stage === 3) {
            const summary = this.humanReviewSummary();
            return `${summary.reviewed_count || 0} / ${summary.total_count || 0}건`;
        }
        if (stage === 4) {
            return this.qualityGatePassed(this.currentQualityGate)
                ? '품질 게이트 통과' : '품질 점검 필요';
        }
        return this.workflowStageDone(5) ? '최종 발행 준비' : '검수 완료 후 생성';
    }

    public exampleNodeLabel(reference: any): string {
        const key = String(reference || '');
        const node = this.reviewedExampleNodes.find((item: any) => item.id === key);
        return String(node?.label || key || '-').split('\n')[0];
    }

    public async selectExampleFact(fact: any) {
        this.selectedExampleFact = fact;
        await this.service.render();
    }

    public graphFactPreview(): any[] {
        return (this.snapshotData?.edges || [])
            .filter((item: any) => (item?.evidence || item?.evidence_links || []).length)
            .slice(0, 20);
    }

    public async selectGraphFact(item: any) {
        this.selectedGraphItem = { kind: 'fact', data: item };
        await this.service.render();
    }

    public selectedKind(): string {
        if (this.selectedGraphItem?.kind !== 'fact') {
            const node = this.selectedGraphItem?.data || {};
            const nodeKind = node?.node_kind
                || node?.candidate_kind
                || node?.provenance?.generalized_node_kind
                || (node?.node_type === 'Event' ? 'event' : 'entity');
            if (!node?.canonical_entity_id) {
                return nodeKind === 'event'
                    ? 'Provisional Event Candidate'
                    : 'Provisional Entity Candidate';
            }
            return nodeKind === 'event' ? 'Canonical Event' : 'Canonical Entity';
        }
        const item = this.selectedGraphItem?.data || {};
        return item?.status === 'published' && item?.canonical_fact_id
            ? 'Canonical Fact'
            : 'Provisional Relation';
    }

    public selectedNodeKind(): string {
        const node = this.selectedGraphItem?.data || {};
        return String(
            node?.node_kind
            || node?.candidate_kind
            || node?.provenance?.generalized_node_kind
            || '-'
        );
    }

    public selectedEvidence(): any[] {
        const item = this.selectedGraphItem?.data || {};
        return item?.evidence || item?.evidence_links || item?.evidence_spans || [];
    }

    public statusLabel(value: any): string {
        const status = String(value || 'published');
        const labels: any = {
            provisional: '검토 중 근거 그래프',
            published: '발행 사실',
            current: '현재',
            superseded: '이전 버전',
            rolled_back: '되돌림'
        };
        return labels[status] || status;
    }

    public snapshotLabel(item: any): string {
        const scope = item?.id === this.currentSnapshotId ? '현재' : '이력';
        return `${scope} · ${item?.version || item?.id || '-'} · ${item?.published_at || item?.created_at || '-'}`;
    }

    public runGraphLayout() {
        if (!this.graphInstance) return;
        if (this.activeGraphLayout) {
            try { this.activeGraphLayout.stop(); } catch (_error) { }
        }
        this.activeGraphLayout = this.graphInstance.layout({
            name: this.viewMode === 'example' ? 'preset' : this.graphLayout,
            fit: true,
            padding: this.viewMode === 'example' ? 56 : 32,
            animate: false
        });
        this.activeGraphLayout.run();
    }

    private scheduleGraphInit() {
        if (!this.viewReady) return;
        if (this.graphInitTimer) clearTimeout(this.graphInitTimer);
        this.graphInitTimer = setTimeout(() => {
            this.graphInitTimer = null;
            this.initializeGraph();
        }, 50);
    }

    private destroyGraph() {
        if (this.activeGraphLayout) {
            try { this.activeGraphLayout.stop(); } catch (_error) { }
            this.activeGraphLayout = null;
        }
        if (this.graphInstance) this.graphInstance.destroy();
        this.graphInstance = null;
    }

    private initializeGraph() {
        const exampleMode = this.viewMode === 'example';
        const container = document.getElementById(
            exampleMode
                ? 'reviewed-example-knowledge-graph'
                : 'instance-knowledge-graph'
        );
        if (!container) return;
        this.destroyGraph();

        const sourceNodes = exampleMode
            ? this.reviewedExampleNodes
            : (this.snapshotData?.nodes || []);
        const nodes = sourceNodes.map((item: any) => {
            const element: any = {
                data: {
                    // Snapshot edges reference the immutable node_key, not the
                    // storage-row id. Keeping Cytoscape on the same key preserves
                    // every candidate/canonical endpoint in the rendered graph.
                    id: String(item?.node_key || item?.id),
                    label: item?.canonical_name || item?.preferred_label || item?.label || item?.id,
                    entityType: item?.node_type || item?.entity_type || item?.type || 'Entity',
                    status: item?.status || (exampleMode ? 'approved' : 'published'),
                    payload: item
                },
                classes: String(item?.status || (exampleMode ? 'approved' : 'published'))
            };
            if (exampleMode && item?.position) element.position = item.position;
            return element;
        });
        const graphEdges = exampleMode
            ? this.reviewedExampleFacts
            : Array.isArray(this.snapshotData?.edges)
            && this.snapshotData.edges.length
            ? this.snapshotData.edges
            : (this.snapshotData?.canonical_facts || []);
        const edges = graphEdges.map((item: any) => {
            const status = String(
                item?.human_review?.decision
                || item?.status
                || (exampleMode ? 'approved' : 'published')
            );
            return {
                data: {
                    id: String(item?.id),
                    source: String(item?.subject_node_key || item?.subject_entity_id || item?.subject_id || ''),
                    target: String(item?.object_node_key || item?.object_entity_id || item?.object_id || ''),
                    label: item?.predicate || 'RELATED_TO',
                    status,
                    payload: item
                },
                classes: status
            };
        }).filter((item: any) => item.data.source && item.data.target);

        this.graphInstance = cytoscape({
            container,
            elements: [...nodes, ...edges],
            layout: { name: 'preset' },
            minZoom: 0.25,
            maxZoom: 3,
            userPanningEnabled: true,
            userZoomingEnabled: true,
            style: [
                {
                    selector: 'node',
                    style: {
                        'background-color': '#0f766e',
                        'border-color': '#115e59',
                        'border-width': 2,
                        'label': 'data(label)',
                        'font-size': 10,
                        'text-wrap': 'wrap',
                        'text-max-width': 120,
                        'text-valign': 'bottom',
                        'text-margin-y': 7,
                        'color': '#0f172a',
                        'width': 32,
                        'height': 32
                    }
                },
                {
                    selector: 'node.provisional',
                    style: {
                        'background-color': '#f59e0b',
                        'border-color': '#92400e',
                        'border-style': 'dashed'
                    }
                },
                {
                    selector: 'node[entityType = "Person"]',
                    style: { 'background-color': '#7c3aed', 'border-color': '#5b21b6' }
                },
                {
                    selector: 'node[entityType = "Event"]',
                    style: { 'background-color': '#ea580c', 'border-color': '#9a3412' }
                },
                {
                    selector: 'node[entityType = "Place"]',
                    style: { 'background-color': '#0f766e', 'border-color': '#115e59' }
                },
                {
                    selector: 'node[entityType = "TimePeriod"]',
                    style: { 'background-color': '#2563eb', 'border-color': '#1e40af' }
                },
                {
                    selector: 'node[entityType = "Artifact"]',
                    style: { 'background-color': '#be185d', 'border-color': '#831843' }
                },
                {
                    selector: 'edge',
                    style: {
                        'line-color': '#64748b',
                        'target-arrow-color': '#64748b',
                        'target-arrow-shape': 'triangle',
                        'curve-style': 'bezier',
                        'label': 'data(label)',
                        'font-size': 8,
                        'text-background-color': '#ffffff',
                        'text-background-opacity': 0.9,
                        'text-background-padding': 2
                    }
                },
                {
                    selector: 'edge.provisional',
                    style: {
                        'line-color': '#f59e0b',
                        'target-arrow-color': '#f59e0b',
                        'line-style': 'dashed'
                    }
                },
                {
                    selector: 'edge.approved',
                    style: {
                        'line-color': '#059669',
                        'target-arrow-color': '#059669',
                        'width': 2.5
                    }
                },
                {
                    selector: 'edge.hold',
                    style: {
                        'line-color': '#d97706',
                        'target-arrow-color': '#d97706',
                        'line-style': 'dashed'
                    }
                },
                {
                    selector: 'edge.rejected',
                    style: { 'display': 'none' }
                },
                {
                    selector: ':selected',
                    style: { 'border-color': '#7c3aed', 'border-width': 4 }
                }
            ]
        });
        this.graphInstance.on('tap', 'node', (event: any) => {
            if (exampleMode) return;
            this.selectedGraphItem = { kind: 'entity', data: event.target.data('payload') };
            this.service.render();
        });
        this.graphInstance.on('tap', 'edge', (event: any) => {
            const payload = event.target.data('payload');
            if (exampleMode) this.selectedExampleFact = payload;
            else this.selectedGraphItem = { kind: 'fact', data: payload };
            this.service.render();
        });
        this.runGraphLayout();
    }
}

export default PageGraphComponent;